import { useMutation, useQueryClient } from "@tanstack/react-query";

import { managementSignalsApiQueryKeys } from "app/pages/sales-intelligence/modules/management/sub-modules/signals-api/query/key-factory/queryKeyFactory";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useUploadDomainsFile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: { file: File; mode: string }): Promise<Response> => {
            const formData = new FormData();

            formData.append("file", data.file);
            return salesApiService.management.uploadDomainsList(formData, data.mode);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: managementSignalsApiQueryKeys.getStatus() });
        },
    });
};
